export default {"src":"/_next/static/media/app.fbc8b356.svg","height":795,"width":795,"blurWidth":0,"blurHeight":0};